import en from "./en.json";
import de from "./de.json";
import de_custom from "./de_custom.json";
import de_custom_7 from "./de_custom_7.json";
import de_custom_1631 from "./de_custom_1631.json";

const mergeLocales = (...sources) => Object.assign({}, ...sources);

const locales = {
  en,
  de,
  de_custom: mergeLocales(de, de_custom),
  de_custom_7: mergeLocales(de, de_custom, de_custom_7),
  de_custom_1631: mergeLocales(de, de_custom, de_custom_1631),
};

export default locales;
